import * as React from "react";
const SvgDownarrow = (props) => /* @__PURE__ */ React.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 10 5", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M10 0L5 5L4.37114e-07 -8.74228e-07L10 0Z", fill: "currentColor" }));
export default SvgDownarrow;
